import { X } from 'lucide-react';
import { DOCUMENT_CATEGORY_LABELS, type DocumentCategory } from '../../types/document';

interface DocumentFilterBarProps {
  selectedCategory: DocumentCategory | null;
  onCategoryChange: (category: DocumentCategory | null) => void;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  onSortChange: (field: string, order: 'asc' | 'desc') => void;
}

const SORT_OPTIONS = [
  { value: 'uploaded_at', label: 'Upload Date' },
  { value: 'document_date', label: 'Document Date' },
  { value: 'filename', label: 'Filename' },
  { value: 'document_category', label: 'Category' },
];

export function DocumentFilterBar({
  selectedCategory,
  onCategoryChange,
  sortField,
  sortOrder,
  onSortChange,
}: DocumentFilterBarProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      {/* Category filter */}
      <div className="flex items-center gap-2">
        <select
          value={selectedCategory || ''}
          onChange={(e) => onCategoryChange((e.target.value || null) as DocumentCategory | null)}
          className="text-sm border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-1.5 bg-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-gray-900 dark:text-gray-100"
        >
          <option value="">All Categories</option>
          {Object.entries(DOCUMENT_CATEGORY_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
        {selectedCategory && (
          <button
            onClick={() => onCategoryChange(null)}
            className="p-1 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X size={14} />
          </button>
        )}
      </div>

      {/* Sort control */}
      <div className="flex items-center gap-1 ml-auto">
        <span className="text-xs text-gray-500 dark:text-gray-400">Sort:</span>
        <select
          value={sortField}
          onChange={(e) => onSortChange(e.target.value, sortOrder)}
          className="text-sm border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1.5 bg-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-gray-900 dark:text-gray-100"
        >
          {SORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <button
          onClick={() => onSortChange(sortField, sortOrder === 'asc' ? 'desc' : 'asc')}
          className="px-2 py-1.5 text-sm text-gray-600 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
        >
          {sortOrder === 'asc' ? '\u2191' : '\u2193'}
        </button>
      </div>
    </div>
  );
}
